<template lang="pug">
  div
    b-row.mb-4.align-items-center
      b-col(md="6", order="2", order-md="1")
        b-input-group
          b-form-input(placeholder="Buscar cuenta...", type="search", v-model="search_text")
          b-input-group-append
            b-button(variant="soft-secondary")
              .d-flex.align-items-center
                b-spinner(small, v-if="loading", variant="primary")
                search-icon.icon-sm(v-else)
                span.ml-2(v-if="$breakpoint.mdUp") Buscar
      b-col.text-right.mb-3.mb-md-0(md="6", order="1", order-md="2", v-if="noAccounts && isKonverzaUser")
        b-button(variant="primary", @click="createKonverzaDirectAccount")
          plus-circle-icon.icon-md.mr-2
          span Crear Chatbot
    b-row(v-if="accounts.length")
      b-col(md="6", v-for="(account, account_index) in accounts", :key="account_index")
        b-card
          b-row.align-items-center
            b-col
              small.text-help.uppercase Cuenta {{ account.account_id }}
              h4 {{ account.name }}
              p.text-help.mb-0 Última actualización {{ $moment(account.updatedAt).fromNow() }}
            b-col(cols="auto")
              b-button(v-if="account.is_active", variant="primary", :to="{ name: 'account', params: { account_id: account.account_id } }") Entrar
              b-button(v-else, variant="warning", :to="{ name: 'PaymentSubscription', params: { account_id: account.account_id } }") Pagar
      b-col(md="12")
        .d-flex.align-items-center.mb-3
          b-pagination.mb-0(:value="paginationCurrentPage", @change="paginationPageChanged($event, 'getAccounts')", :per-page="v_paginationLimit", :total-rows="v_paginationItemsCount", v-if="v_paginationShow")
    empty-message(v-else, message="No hay cuentas")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import _debounce from 'lodash.debounce'

const accountController = createNamespacedHelpers('account')

export default {
  data () {
    return {
      search_text: '',
      loading: false,
      noAccounts: false
    }
  },
  computed: {
    ...accountController.mapState({
      accounts: state => state.accounts
    }),
    User () {
      return this.getCurrentUser()
    },
    isKonverzaUser () {
      try {
        let is = (new RegExp('^konverza', 'i')).test(this.User.role_type)
        return is
      } catch (e) {
        console.error(e.message)
        return false
      }
    }
  },
  methods: {
    ...mapActions(['account/all', 'admin/get']),
    async createKonverzaDirectAccount () {
      this.showLoadingScreen()

      this['admin/get']({
        admin_id: this.getCurrentUser().admin_id,
        callback: res => {
          this.hideLoadingScreen()
          if (res.error) {
            this.$message.error(res.error)
          } else {
            if (res.resource && res.resource.Organizations && res.resource.Organizations.length) {
              this.$router.push({name: 'package', params:{organization_id: res.resource.Organizations[0].organization_id} }).catch(()=>{});
            } else {
              this.$message.warning('No tienes los permisos suficientes para crear cuentas')
            }
          }
        }
      })
    }
  },
  mounted () {
    this.getAccounts = _debounce(() => {
      const self = this
      this.loading = true
      const params = { ...self.paginationParamsObject }

      if (self.search_text) params.name = self.search_text

      this['account/all']({
        admin_id: self.getCurrentUser().admin_id,
        params,
        callback: res => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)

          self.parsePaginationDataFromResponse(res)

          if (
            res.resource &&
            Array.isArray(res.resource) &&
            !res.resource.length
          ) {
            this.noAccounts = true
          }
        }
      })
    }, 300, { leading: false, trailing: true })

    this.getAccounts()
  },
  watch: {
    search_text () {
      this.resetPaginationData()
      this.getAccounts()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
